import { render, staticRenderFns } from "./DanhSachVaiTroKhongThuocGroup.vue?vue&type=template&id=7f57dca0&"
import script from "./DanhSachVaiTroKhongThuocGroup.vue?vue&type=script&lang=js&"
export * from "./DanhSachVaiTroKhongThuocGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports